// extracted by mini-css-extract-plugin
module.exports = {"product":"utUoUf","root":"VkDR_t","slider":"dDJbXr","favorites":"hnFg3U","sliderControls":"rV8B60","seeMoreButton":"D0uHtv"};